module.exports = __webpack_public_path__ + "img/1300m.6448b8d9.png";